mutation RequestTwitchConnectUrl($returnOrigin: String) {
  connectUrl: StreamToolsRequestTwitchConnectUrl(returnOrigin: $returnOrigin) {
    url
    expiresAt
  }
}
